import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../components/AppIcon';
import Header from '../../components/ui/Header';

const FarmaCityService = () => {
  const navigate = useNavigate();

  const services = [
    {
      id: 1,
      title: 'Invia Ricetta alla Farmacia',
      description: 'Carica la ricetta e inviala alla farmacia scelta per la consegna.',
      icon: 'FileText',
      link: '/farma-service-city/invio-ricetta',
    },
    {
      id: 2,
      title: 'Orari e Turni Farmacie',
      description: 'Consulta gli orari di apertura e i turni delle farmacie vicine.',
      icon: 'Clock',
      link: '/farma-service-city/orari-turni',
    },
    {
      id: 3,
      title: 'Centri Medici Privati',
      description: 'Richiedi visite ed esami specialistici presso strutture locali.',
      icon: 'Stethoscope',
      link: '/farma-service-city/centri-medici',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Shared Header Component */}
      <Header onFilterClick={() => {}} />

      {/* Hero Section */}
      <section className="relative w-full py-12 md:py-16 lg:py-20 overflow-hidden">
        {/* Background Image with Blur */}
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: 'url(/assets/images/FarmaciaHome-1771148543553.jpeg)',
            filter: 'blur(8px)',
            transform: 'scale(1.1)'
          }}
        />
        
        {/* White/Green Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-white/75 via-green-50/80 to-white/75" />
        
        {/* Content */}
        <div className="relative z-10 max-w-screen-xl mx-auto px-4 md:px-6">
          <div className="flex flex-col items-center text-center">
            {/* Green Cross Image + Title */}
            <div className="flex items-center justify-center gap-4 md:gap-6 mb-6">
              <img
                src="/assets/images/iCroceFarma-1771150698768.jpg"
                alt="Croce verde farmacia"
                className="w-16 h-16 md:w-20 md:h-20 object-contain drop-shadow-lg"
              />
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-green-600 drop-shadow-sm">
                FarmaCityService
              </h1>
            </div>

            {/* Subtitle */}
            <p className="text-lg md:text-xl text-gray-800 font-medium max-w-2xl drop-shadow-sm">
              Le Farmacie ed i Servizi Sanitari della Tua Città
            </p>
          </div>
        </div>
      </section>

      {/* Action Cards Section */}
      <section className="w-full bg-white py-12 md:py-16 lg:py-20">
        <div className="max-w-screen-xl mx-auto px-4 md:px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            {services?.map((service) => (
              <div
                key={service?.id}
                className="bg-white border border-gray-200 rounded-xl shadow-md hover:shadow-lg transition-shadow p-8 flex flex-col items-center text-center"
              >
                {/* Green Icon */}
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-6">
                  <Icon name={service?.icon} size={32} className="text-green-600" />
                </div>

                {/* Title */}
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {service?.title}
                </h3>

                {/* Description */}
                <p className="text-sm text-gray-600 mb-6 flex-grow">
                  {service?.description}
                </p>

                {/* Green Button */}
                <button
                  onClick={() => navigate(service?.link)}
                  className="bg-green-600 hover:bg-green-700 text-white font-semibold px-6 py-3 rounded-lg shadow-md transition-all duration-200 hover:shadow-lg w-full"
                >
                  Apri
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="w-full bg-gray-50 border-t border-gray-200 py-6">
        <div className="max-w-screen-xl mx-auto px-4 md:px-6 text-center">
          <p className="text-xs text-gray-500">
            I dati sanitari saranno trattati esclusivamente per l'evasione della richiesta.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default FarmaCityService;